
<div class="form-horizontal">
    <div class="form-group">
        <label for="txtLocationName" class="control-label col-md-2">{{ 'LocationName' | translate}}</label>
        <div class="col-md-4">
            <input type="text" class="form-control" id="txtLocationName" name="txtLocationName" required>
        </div>
    </div>
</div>
